export default {
  navHome: "Inicio",
  navProducts: "Productos",
  navCases: "Casos de aplicación",
  navAbout: "Sobre nosotros",
  deliverTo: "Entregar a:",
  langCurrencyLabel: "Español",
  localeLangTitle: "Configurar idioma",
  localeLangDesc:
    "Seleccione su idioma preferido. Puede actualizar esta configuración en cualquier momento.",
  language: "Idioma",
  save: "Guardar",
  coreProducts: "Impulsando la creación en el mundo real.",
  coreProductsDesc:
    "De la idea al negocio �?YONGYUAN ofrece impresoras UV, impresoras de etiquetas cristal, impresoras cilíndricas de alta velocidad, impresoras DTF y DTG, transformando la creatividad en productos, marcas y oportunidades.",
  scenariosTitle: "Soluciones para cada escenario",
  scenariosDesc:
    "Ya sea que esté construyendo una marca, desarrollando un negocio paralelo o persiguiendo pasiones creativas, YONGYUAN ofrece una solución adaptada a sus necesidades.",
  scenarioStudio: "Estudio",
  scenarioStudioDesc:
    "Personalización de alto valor, prototipado en pequeños lotes y construcción de marca",
  scenarioRetail: "Retail de marca",
  scenarioRetailDesc:
    "Aumentar el tiempo de permanencia y los ingresos en tienda",
  scenarioMarket: "Mercado callejero",
  scenarioMarketDesc:
    "Personalización en el lugar, venta de productos terminados e ingresos adicionales",
  scenarioEnterprise: "Personalización empresarial",
  scenarioEnterpriseDesc:
    "Personalización por lotes, merchandising de marca y regalos corporativos",
  scenarioEcommerce: "Venta en vivo",
  scenarioEcommerceDesc:
    "Muestras de productos exitosos, suministro flexible y lanzamientos rápidos",
  scenarioStore: "Tienda online",
  scenarioStoreDesc:
    "Personalización de tienda, merchandising exitoso y operaciones diferenciadas",
  scenarioFactory: "Producción en fábrica",
  scenarioFactoryDesc:
    "Fabricación por lotes, producción estable y operaciones rentables",
  scenarioAdvertising: "Producción publicitaria",
  scenarioAdvertisingDesc:
    "Señalización, materiales de exhibición y materiales para eventos",
  industries: "Aplicaciones industriales",
  industriesDesc:
    "Soluciones de impresión por inyección de tinta digital para impresión a color en diversos sectores.",
  applicationsTitle:
    "Desbloquee aplicaciones versátiles de materiales y colores para necesidades cotidianas y comerciales.",
  applicationsDesc:
    "Los equipos de impresión UV YONGYUAN están diseñados para una amplia gama de materiales y escenarios de proceso, permitiendo personalización y producción a gran escala.",
  casesHeroDesc:
    "Más de 1200 aplicaciones industriales y decenas de miles de materiales imprimibles: soluciones de impresión digital para distintos negocios.",
  casesBreadcrumbHome: "Inicio",
  casesBreadcrumbCenter: "Casos de aplicación",
  casesEmpty: "Aún no hay casos de aplicación en esta categoría.",
  customerStoriesTitle: "Con la confianza de clientes en todo el mundo",
  customerStoriesSubtitle:
    "Instalaciones reales, clientes reales, negocios de impresión reales en 172 países.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Impresoras entregadas",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Países atendidos",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Años de experiencia",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Soporte técnico",
  customerStoriesPlaceholder: "Añadir foto del cliente",
  customerStoriesPhotoAlt: "Cliente YONGYUAN con impresora",
  servicePartnerTitle:
    "Conozca al equipo de servicio YONGYUAN, su socio creativo",
  servicePartnerDesc:
    "Una red de servicio global y sistema de soporte profesional para proteger el rendimiento de su equipo y el crecimiento de su negocio.",
  serviceSupportTitle: "Soporte estándar",
  serviceSupportDesc:
    "Orientación de instalación, formación básica y asistencia de uso diario para mantener el equipo funcionando de forma fiable.",
  servicePresaleTitle: "Demostración y consulta previa a la venta",
  servicePresaleDesc:
    "Demostraciones de soluciones y recomendaciones de modelos adaptadas a sus escenarios de aplicación y requisitos de capacidad.",
  serviceLifetimeTitle: "Soporte técnico de por vida",
  serviceLifetimeDesc:
    "Respuesta técnica continua y soporte de procesos para acompañar su desarrollo empresarial a largo plazo.",
  serviceCareTitle: "Actualice a YONGYUAN Care",
  serviceCareDamageTitle: "Protección contra daños accidentales",
  serviceCareDamageDesc:
    "Un plan de protección más completo para reducir pérdidas causadas por incidentes inesperados.",
  serviceCareExchangeTitle: "Servicio de intercambio rápido",
  serviceCareExchangeDesc:
    "Arreglos prioritarios de intercambio rápido bajo condiciones elegibles para acelerar la recuperación de capital.",
  viewProduct: "Ver productos",
  learnMore: "Más información",
  catUv: "Impresora UV de mesa",
  catCylinder: "Impresora cilíndrica",
  catCrystal: "Impresora de etiqueta cristal",
  catDtf: "Impresora DTF",
  catDtg: "Impresora DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Teléfono: 17748697567 Gerente Tang",
  email: "Correo: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Todos los derechos reservados",
  productsHeroTitle: "Productos",
  productsHeroDesc:
    "Línea completa de equipos UV de mesa, cilíndricos, etiquetas cristal, DTF y DTG para diversas necesidades de capacidad y aplicación.",
  productsBreadcrumbHome: "Inicio",
  productsBreadcrumbCenter: "Productos",
  productsEmpty: "Los productos de esta categoría estarán disponibles pronto.",
  productsQuoteTitle: "Solicitar solución y presupuesto",
  productsQuoteDesc:
    "Comparta sus escenarios de aplicación y requisitos de capacidad, y le recomendaremos la solución de equipo adecuada.",
  productsContact: "Contáctenos",
  aboutHeroTitle: "Sobre Yongyuan",
  aboutHeroDesc:
    "23 años enfocados en I+D y producción de equipos de impresión UV",
  productA23Subtitle: "Impresora UV inteligente de 6 colores de escritorio",
  productA23Feature1: "Formato de impresión A4",
  productA23Feature2: "Sistema inteligente de suministro de tinta",
  productA23Feature3: "Detección automática de altura por infrarrojos",
  productA35Subtitle: "Impresora UV inteligente de 6 colores de escritorio",
  productA35Feature1: "Formato de impresión A3+",
  productA35Feature2: "Sistema inteligente de suministro de tinta",
  productA35Feature3: "Detección automática de altura por infrarrojos",
  productA43Subtitle: "Impresora UV inteligente de 8 colores insignia",
  productA43Feature1: "Formato de impresión A3",
  productA43Feature2: "Múltiples configuraciones de cabezales",
  productA43Feature3: "Sistema inteligente de suministro de tinta",
  productA46Subtitle: "Impresora UV inteligente de 8 colores insignia",
  productA46Feature1: "Formato de impresión A2",
  productA46Feature2: "Múltiples configuraciones de cabezales",
  productA46Feature3: "Sistema inteligente de suministro de tinta",
  productA57Subtitle: "Impresora UV inteligente de 8 colores insignia",
  productA57Feature1: "Formato de impresión A2+",
  productA57Feature2: "Múltiples configuraciones de cabezales",
  productA57Feature3: "Sistema inteligente de suministro de tinta",
  productA69Subtitle: "Impresora UV inteligente de 8 colores insignia",
  productA69Feature1: "Formato de impresión A1",
  productA69Feature2: "Múltiples configuraciones de cabezales",
  productA69Feature3: "Sistema inteligente de suministro de tinta",
  productA1216Subtitle: "Impresora UV de mesa gran formato insignia",
  productA1216Feature1: "Formato de impresión 1200×1600cm",
  productA1216Feature2: "Múltiples configuraciones de cabezales",
  productA1216Feature3: "Sistema de posicionamiento visual",
  productA2513Subtitle: "Impresora UV de mesa gran formato insignia",
  productA2513Feature1: "Formato de impresión 2500×1300cm",
  productA2513Feature2: "Múltiples configuraciones de cabezales",
  productA2513Feature3: "Sistema de posicionamiento visual",
  productCylinderElfSubtitle: "Impresora cilíndrica de alta velocidad 360°",
  productCylinderElfFeature1: "Impresión 360°",
  productCylinderElfFeature2: "Personalización de tazas y botellas",
  productCylinderElfFeature3: "Cambio rápido de dispositivos",
  productCupPlusSubtitle: "Solución de impresión multi-tamaño para tazas y botellas",
  productCupPlusFeature1: "Dispositivos multi-tamaño",
  productCupPlusFeature2: "Alta eficiencia de producción",
  productCupPlusFeature3: "Producción estable",
  productCrystal60Subtitle: "Sistema todo-en-uno de impresión y foil de etiquetas cristal",
  productCrystal60Feature1: "Ancho de 60cm",
  productCrystal60Feature2: "Integración de impresión y foil",
  productCrystal60Feature3: "Sistema de recogida eficiente",
  productCrystalC60UltraFeature1: "Ancho 60 cm",
  productCrystalC60UltraFeature2: "Opciones foil oro/plata/etiqueta silicona 3D",
  productCrystalC60UltraFeature3: "Producción en masa",
  productCrystal30Subtitle: "Impresora compacta de alta precisión para etiquetas cristal",
  productCrystal30Feature1: "Impresión de precisión compacta",
  productCrystal30Feature2: "Operación fácil",
  productCrystal30Feature3: "Personalización individual",
  productDtf60Subtitle: "Impresora de transferencia DTF con tinta blanca",
  productDtf60Feature1: "Transferencia DTF con tinta blanca",
  productDtf60Feature2: "Capas de color ricas",
  productDtf60Feature3: "Accesorios de vestimenta",
  productDtfF20Subtitle: "La impresora DTF de tinta blanca de escritorio más compacta del sector",
  productDtfF20Feature1: "Tamaño A4",
  productDtfF20Feature2: "Personalización en pequeños lotes",
  productDtfF20Feature3: "Sistema inteligente de tinta",
  productDtfF30Subtitle: "Impresora DTF de tinta blanca de escritorio",
  productDtfF30Feature1: "Tamaño A3",
  productDtfF30Feature2: "Cabezal único manual/automático opcional",
  productDtfF30Feature3: "Sistema inteligente de tinta",
  productDtfF30ProSubtitle: "Impresora DTF de tinta blanca",
  productDtfF30ProFeature1: "Tamaño A3",
  productDtfF30ProFeature2: "Doble cabezal con recogida automática de film",
  productDtfF30ProFeature3: "Sistema inteligente de tinta",
  productDtfF33Subtitle: "Impresora DTF de tinta blanca",
  productDtfF33Feature1: "Tamaño A3",
  productDtfF33Feature2: "Cabezal único manual/automático opcional",
  productDtfF33Feature3: "Sistema inteligente de tinta",
  productDtfF70ProSubtitle: "Impresora DTF de tinta blanca de formato ancho 70 cm",
  productDtfF70ProFeature1: "Tamaño A2",
  productDtfF70ProFeature2: "Opciones de 2 a 4 cabezales",
  productDtfF70ProFeature3: "Sistema automático de alimentación y salida",
  productDtfF70ProFeature4: "Modo inteligente de reanudación de impresión",
  productDtf30Subtitle: "Impresora DTF compacta con tinta blanca",
  productDtf30Feature1: "Personalización en pequeños lotes",
  productDtf30Feature2: "Reproducción de color precisa",
  productDtf30Feature3: "Fácil de usar",
  productDtgPrintSubtitle: "Impresora digital directa a prenda",
  productDtgPrintFeature1: "Impresión directa multi-material",
  productDtgPrintFeature2: "Alto rendimiento",
  productDtgPrintFeature3: "Estable y duradero",
  productDtg3250DSubtitle: "Único modelo 2 en 1 DTF y DTG de la industria",
  productDtg3250DFeature1: "Formato A3+",
  productDtg3250DFeature2: "Impresión dual DTF y DTG",
  productDtg3250DFeature3: "Sistema inteligente de tinta",
  productDtg3646TSubtitle: "Impresora DTG de doble estación",
  productDtg3646TFeature1: "Modo de producción continua",
  productDtg3646TFeature2: "100% más de productividad",
  productDtg3646TFeature3: "Sistema inteligente de tinta",
  productDtgMaxSubtitle: "Impresora DTG digital industrial",
  productDtgMaxFeature1: "Capacidad industrial",
  productDtgMaxFeature2: "Estable y duradero",
  productDtgMaxFeature3: "Operación continua",
  app01Title: "Fundas de móvil",
  app02Title: "Pelotas de golf",
  app03Title: "Placas de piedra",
  app04Title: "Bolígrafos",
  app05Title: "Estuches para gafas",
  app06Title: "Grabados en madera",
  app07Title: "Latas de bebidas",
  app08Title: "Teclados",
  app09Title: "Termos",
  app10Title: "Equipaje",
  app11Title: "Productos de acrílico",
  app12Title: "Cuadernos",
  app13Title: "Insignias",
  app14Title: "Tarjeteros de cuero",
  app15Title: "Placas de identificación",
  app16Title: "Arte en vidrio",
  appDtgCase01: "Camisetas",
  appDtgCase02: "Sudaderas",
  regionCn: "China",
  regionUs: "Estados Unidos",
  regionGb: "Reino Unido",
  regionDe: "Alemania",
  regionAe: "EAU",
  regionIn: "India",
  regionJp: "Japón",
  regionVn: "Vietnam",
  regionBr: "Brasil",
  regionAu: "Australia",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
